// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tn-0";